import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'primereact/button'
import pitCrewImage from '../assets/image/pit-crew.png'

const NotFound: FC = () => {
  const navigate = useNavigate()

  return (
    <div className="basis-0 grow flex flex-col items-center justify-center w-full h-full p-8">
      <div className="flex flex-col items-center max-w-3xl">
        <img 
          src={pitCrewImage} 
          alt="Pit Crew" 
          className="w-full max-w-2xl mb-8 rounded-lg shadow-lg"
        />
        <h1 className="text-2xl font-bold text-center mb-6">
          Sorry but looks like this page pulled into the wrong pit. We're working on it!
        </h1>
        <Button 
          label="Go to Home Page" 
          icon="pi pi-home"
          onClick={() => navigate('/')}
          className="info"
          iconPos="left"
          pt={{
            icon: { className: 'mr-2' }
          }}
        />
      </div>
    </div>
  )
}

export default NotFound
